<template>
    <v-dialog v-model="dialog" width="800px" class="pa-0 ma-0">
        <v-card>
            <v-card-title class="justify-center">Create/Edit Faq entry</v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <v-row class="pa-2 ma-0">
                    <v-col cols=2 class="pa-2">Language</v-col><v-col cols=10 class="pa-2"><v-select v-model="faq.language" :disabled="editMode" :items="languageCodes" item-value="Option" item-text="Description" dense></v-select></v-col>
                    <v-col cols=2 class="pa-2">Category</v-col><v-col cols=10 class="pa-2"><v-select v-model="faq.categoryCode" :disabled="editMode" :items="categoryCodes" item-value="Option" item-text="Description" dense></v-select></v-col>
                    <v-col cols=2 class="pa-2">Question</v-col><v-col cols=10 class="pa-2"><v-textarea v-model="faq.question" rows="4" dense></v-textarea></v-col>
                    <v-col cols=2 class="pa-2">Answer  </v-col><v-col cols=10 class="pa-2"><v-textarea v-model="faq.answer" rows="4" dense></v-textarea></v-col>
                </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" small @click="saveFaq(true)">Save & Close</v-btn>
                <v-btn color="primary" small @click="cancelDialog()">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

    export default {
        components: {
        },
        props: {
        },
        data() {
            return {
                dialog: false,
                editMode: true,
                languageCodes: [],
                categoryCodes: [],

                faq: {},
                orgFaq: {},
            }
        },
        methods: { 
            openDialog(faq, languageCodes, categoryCodes) {
                this.orgFaq = {
                    language: faq.language,
                    categoryCode: faq.categoryCode,
                    question: faq.question,
                    answer: faq.answer,                    
                } 
                // console.log(faq)
                this.editMode = faq.oava_encrid !== "";
                this.faq = faq;
                this.languageCodes = languageCodes;
                this.categoryCodes = categoryCodes;
                this.dialog = true;
            },
            cancelDialog() {
                this.faq.language = this.orgFaq.language;
                this.faq.categoryCode = this.orgFaq.categoryCode;
                this.faq.question = this.orgFaq.question;
                this.faq.answer = this.orgFaq.answer;

                this.closeDialog();
            },
            closeDialog() {
                this.$emit("actionClick", "refresh")
                this.dialog = false;
            },
            saveFaq(option) {
                if (this.faq.language === "") {
                    this.$store.dispatch("setSnackbar", {
                        showing: true,
                        text: "Please add a language",
                        color: "error",
                    });  
                    return
                }
                if (this.faq.categoryCode === "") {
                    this.$store.dispatch("setSnackbar", {
                        showing: true,
                        text: "Please add a category",
                        color: "error",
                    });  
                    return
                } 
                this.$axios.post("ares/json/ares/syst/openai/saveFaqGeneral.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "saveFaqGeneral",
                    },
                    saveFaqGeneral: this.faq,
                }).then((res) => {
                    if (res.data.error) {
                        // console.log(res.data.error);
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                    } else {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.saveFaqGeneral.text,
                            color: res.data.saveFaqGeneral.color,
                        });
                        if (option) {
                            this.closeDialog();
                        }
                    }
                });
            },
        }
    }
</script>